import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { PoolStoreAddModalComponent } from '../pool-store-add-modal/pool-store-add-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { PoolClientAddModalComponent } from '../pool-client-add-modal/pool-client-add-modal.component';
import { Router } from '@angular/router';
import { ClientScopesAddComponent } from '../client-scopes-add/client-scopes-add.component';

@Component({
  selector: 'app-pool-point-details',
  templateUrl: './pool-point-details.component.html',
  styleUrls: ['./pool-point-details.component.scss']
})
export class PoolPointDetailsComponent implements ICellRendererAngularComp {
  pool: any;

  clients: any[] = [];
  selectedClient: any = null;
  selectedClientContact: any = null;
  clientScopes: Scope[] = [];

  stores: any[] = [];
  selectedStore: any = null;
  selectedStoreContact: any = null;

  loading = false;

  constructor(private http: HttpClient, private toastr: ToastrService, private dialog: MatDialog, private router: Router) {}

  // Master/detail init
  agInit(params: any): void {
    this.pool = params.data;
    this.loadClients(this.pool.pool_point_uuid);
  }

  refresh(): boolean {
    return false; // stop ag-Grid from re-rendering infinitely
  }

  // Load clients for this pool
  private loadClients(poolPointUuid: string): void {
    // old url: `/api/pool_points/pool_points.php?name=pool_point_clients&pool_point_uuid=${poolPointUuid}`
    this.loading = true;
    this.http
      .get<any>(
        `/api/pool_points/pool_point_clients.php?pool_point_uuid=${poolPointUuid}`
      )
      .subscribe({
        next: (res) => {
          this.clients = res || [];
          this.selectedClient = this.clients.length > 0 ? this.clients[0] : null;
          if (this.selectedClient) {
            this.loadClient(this.selectedClient.pool_point_client_uuid);
            this.loadStores(this.selectedClient.pool_point_client_uuid);
          }
          this.loading = false;
        },
        error: () => {
          this.loading = false;
        }
      });

  }

  selectClient(client: any): void {
    this.selectedClient = client;
    this.loadClient(client.pool_point_client_uuid);
    this.loadStores(client.pool_point_client_uuid);
    this.selectedStore = null;
    this.selectedStoreContact = null;
  }

  private loadClient(clientUuid: string): void{
      if (!clientUuid) {
      this.selectedClientContact = null;
      return;
    }
    this.http
      .get<any>(
        `/api/pool_points/pool_point_clients.php?pool_point_client_uuid=${clientUuid}`
      )
      .subscribe((res) => {
        this.selectedClientContact = res.data || null;
        // if(res.scopes.response){
        //   this.clientScopes = res.scopes.response;
        //   console.log(this.clientScopes)
        // }
        console.log(res)

      });  
  }

  // Load stores for a client
  private loadStores(clientUuid: string): void {
    // old url: `/api/pool_points/pool_points.php?table=pool_point_stores&pool_point_client_uuid=${clientUuid}`
    this.loading = true;
    console.log(clientUuid);
    this.http
      .get<any>(
        `/api/pool_points/pool_point_stores.php?pool_point_client_uuid=${clientUuid}`
      )
      .subscribe({
        next: (res) => {
          console.log('Stores fetched: ', res)
          this.stores = res || [];
          this.loading = false;
        },
        error: (err) => {
          this.loading = false;
        }
      });
  }

  //  When user clicks a store
  // selectStore(store: any): void {
  //   this.selectedStore = store;
  //   this.loadStoreContact(store.pool_point_store_contact_uuid);
  // }

  //  Load contact info for a store
  // private loadStoreContact(contactUuid: string): void {
  //   if (!contactUuid) {
  //     this.selectedStoreContact = null;
  //     return;
  //   }
  //   this.http
  //     .get<any>(
  //       `/api/pool_points/pool_points.php?contacts=contacts&contact_uuid=${contactUuid}`
  //     )
  //     .subscribe((res) => {
  //       this.selectedStoreContact = res.data || null;
  //     });
  // }

  // Delete a store
  deleteStore(store: any){
    if (store['pool_point_store_uuid']){
      const url = `/api/pool_points/pool_point_stores.php`;
      this.http.delete<any>(url, { params: { uuid: store['pool_point_store_uuid'] } }).subscribe(
        response => {
          if(response.code && response.code == "200"){
            this.toastr.success('Store deleted.');
            this.loadStores(this.selectedClient.pool_point_client_uuid);
          }
          else{
            this.toastr.error('Store not deleted.')
          }
        },
        error => {
          console.error(error);
          this.toastr.error('Store not deleted');
        }
      )
    }
  }

  // Add a store
  addStore(){
    if (this.selectedClient === null){
      this.toastr.error('Cannot add a store without a client. Please select or create a client.')
      return;
    }
    this.dialog.open(PoolStoreAddModalComponent, {
      width: '400px',
      disableClose: true,
      data: {
        poolPointClientUuid: this.selectedClient.pool_point_client_uuid,
        poolPointClientName: this.selectedClient.pool_point_client_name,
        poolPointUuid: this.selectedClient.pool_point_uuid
      }
    })
  }

  deleteClient(){
    const url = '/api/pool_points/pool_point_clients.php';
    const uuid = this.selectedClient.pool_point_client_uuid;
    this.http.delete<any>(url, { params: { uuid: uuid}}).subscribe(
      response => {
        console.log(response);
        this.loadClients(this.pool.pool_point_uuid);
      }, 
      error => {
        console.log(error)
      }
    )
  }

  addClient(){
    console.log(`sending pp_uuid: ${this.pool.pool_point_uuid}`)
    this.dialog.open(PoolClientAddModalComponent, {
      width: '400px',
      disableClose: true,
      data: {
        poolPointUuid: this.pool.pool_point_uuid
      }
    });
  }

  editStoreContactInfo(pool_point_store_contact_uuid: string){
    console.log(pool_point_store_contact_uuid);
    this.router.navigate(['/contacts'], { queryParams: { contact_uuid: pool_point_store_contact_uuid } });
  }

  // addScope(){
  //   this.dialog.open(ClientScopesAddComponent, {
  //     width: '400px',
  //     disableClose: true,
  //     data: {
  //       customer_contact_uuid: this.selectedClient.pool_point_client_contact_uuid
  //     }
  //   });
  // }

  // deleteScope(contact_reference_mapping_uuid: string){
  //   const url = `/api/pool_points/pool_point_scopes.php`;
  //   console.log(contact_reference_mapping_uuid);
  //   this.http.delete<any>(url, { params: {contact_reference_mapping_uuid: contact_reference_mapping_uuid}}).subscribe(
  //     response => {
  //       console.log(response);
  //       this.loadClientContact(this.selectedClientContact);
  //       this.toastr.success('Scope deleted');
  //     },
  //     error => {
  //       console.log(error);
  //       this.toastr.error('Could not delete scope');
  //     }
  //   )
  // }
}

export interface Scope{
  contact_reference_mapping_uuid: string,
  reference_code: string,
  reference_scope: string,
  contact_scac: string
}
